import TokenSession from "../session/TokenSession";

//TODO proper error handling
export default class StartupException extends Error {

	constructor(message: string, details?: any) {
		super(message);

		console.error(message);

		// kick back to the gateway
		TokenSession.refresh();
	}

}



// WEBPACK FOOTER //
// ./src/core/util/exception/StartupException.ts